import { DEFAULT_OFFER_TYPE } from "../constants";
/** Matches `offer_type,finance_type,monthly_price` embedded in listing pathname. */
const PATH_SEGMENT_PATTERN = /(company|personal),(leasing|rent|loan),([a-zA-Z0-9-]+)/;
/**
 * Reads path-segment filters from the listing URL (not query string).
 * Used for instant UI sync on history back/forward.
 */
export function parsePathFiltersFromPathname(pathname) {
    const match = pathname.match(PATH_SEGMENT_PATTERN);
    if (!match) {
        return {};
    }
    const [, offer_type, finance_type, monthly_price] = match;
    return {
        offer_type: offer_type || DEFAULT_OFFER_TYPE,
        finance_type,
        monthly_price,
    };
}
